import * as z from "zod";
import { emailContainsPlus } from "@/lib/utils";

export const loginSchema = z.object({
  email: z
    .string()
    .email()
    .refine((val) => !emailContainsPlus(val), {
      message: "Email addresses containing '+' are not allowed",
    }),
  password: z.string().min(6),
});

export const signupSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  email: z
    .string()
    .email()
    .refine((val) => !emailContainsPlus(val), {
      message: "Email addresses containing '+' are not allowed",
    }),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
export type SignupFormValues = z.infer<typeof signupSchema>;
